var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"setHeight"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"go"},[_c('img',{staticClass:"go-top",attrs:{"src":require("../../assets/images/top.png")},on:{"click":function($event){return _vm.scrollTo(0, 0, 700)}}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272ce0cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basicComponents/scroll.vue
// module id = null
// module chunks = 